import { IAPIRoutes } from "../../../../config";
import { getDevicelessApiEndpoint } from "../../../../util/devicelessRouting";

export const WatchlistRepositoryFactory = ({
  APIProvider,
  AuthService,
  APIRoutes,
}: {
  APIProvider: IAPIProvider;
  AuthService: IAuthService;
  APIRoutes: IAPIRoutes;
}) => {
  const { GET, PUT } = APIProvider;
  const { getAuthenticationToken } = AuthService;

  const getWatchlist: IGetWatchlistAPI = async (payload) => {
    const endpoint = getDevicelessApiEndpoint(APIRoutes.apiGetWatchlist);
    return GET(
      endpoint.replace("{clinic_id}", payload.clinic_id?.toString()),
      payload,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );
  };

  const putWatchlist: IPutWatchlistAPI = async ({ clinic_id, items }) =>
    PUT(
      APIRoutes.apiPutWatchlist.replace("{clinic_id}", clinic_id.toString()),
      { items },
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  return {
    getWatchlist,
    putWatchlist,
  };
};
